import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  input: {
    '& .MuiInputBase-input': {
      paddingRight: '10px',
      paddingLeft: '8px'
    }
  },
  inputWithClearIcon: {
    '& .MuiInputBase-input': {
      paddingRight: '16px'
    }
  },
  searchIcon: {
    width: '22px',
    height: '22px'
  },
  closeIconContainer: {
    marginRight: '8px'
  }
});
